document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest('.faq-page-faqlist .item-title[aria-controls]');
  if (!button) return;

  const panelId = button.getAttribute('aria-controls');
  const panel = panelId ? document.getElementById(panelId) : null;
  if (!panel) return;

  const $panel = $(panel);
  const isOpen = button.getAttribute('aria-expanded') === 'true';
  const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400;

  button.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
  button.classList.toggle('active', !isOpen);

  if (isOpen) {
    $panel.stop(true, false).slideUp(duration, () => {
      panel.setAttribute('hidden', '');
      panel.style.display = '';
    });
    return;
  }

  panel.removeAttribute('hidden');
  $panel.stop(true, true).hide().slideDown(duration, () => {
    panel.style.display = '';
  });
});
